var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tw"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.0741 9.61812C25.9782 9.03572 26.6719 8.11221 26.9975 7.01211C26.151 7.55271 25.2156 7.94369 24.2176 8.15535C23.4212 7.23861 22.283 6.66699 21.0234 6.66699C18.6066 6.66699 16.6483 8.77687 16.6483 11.3788C16.6483 11.7482 16.6846 12.1082 16.7597 12.452C13.1234 12.2552 9.89902 10.3812 7.73901 7.52847C7.3621 8.22682 7.14675 9.03572 7.14675 9.89854C7.14675 11.5325 7.91936 12.9751 9.09389 13.8217C8.3764 13.7974 7.70146 13.5831 7.11042 13.2326V13.2906C7.11042 15.5744 8.61805 17.4793 10.6228 17.9107C10.2546 18.0212 9.86896 18.0765 9.46826 18.0765C9.18652 18.0765 8.91105 18.0482 8.64557 17.9929C9.20155 19.8642 10.8181 21.2285 12.7339 21.2649C11.2351 22.5295 9.34803 23.2818 7.29822 23.2818C6.94511 23.2818 6.59576 23.2615 6.25391 23.217C8.19102 24.5531 10.4913 25.3337 12.9631 25.3337C21.0146 25.3337 25.4147 18.1534 25.4147 11.9262C25.4147 11.7212 25.4122 11.5177 25.4034 11.3168C26.2587 10.6521 27.0025 9.82168 27.5872 8.87664C26.8021 9.25144 25.9582 9.5049 25.0741 9.61812Z",
    fill: "#0027F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.af6b5f0f1306ddaffecf246c4ce72b40.svg";
export { ForwardRef as ReactComponent };